module.exports = __webpack_public_path__ + "img/performance-5.a2ed1b8b.png";